// extracted by mini-css-extract-plugin
module.exports = {"defaultfont":"\"Poppins\"","lightweight":"200","mediumweight":"400","boldweight":"600","small-size":".9rem","medium-size":"1rem","large-size":"1.5rem","title-size":"3rem"};